package com.anjuros.website.redesign.sections.faq

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdBreadcrumb
import com.anjuros.website.redesign.components.rdScrollToAfterRender
import com.anjuros.website.redesign.components.RdLede
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.FaqChipsStyle
import com.anjuros.website.redesign.styles.FaqHeroInnerStyle
import com.anjuros.website.redesign.styles.FaqHeroStyle
import com.anjuros.website.redesign.styles.FaqSearchStyle
import com.anjuros.website.redesign.styles.FaqVisuallyHiddenStyle
import com.anjuros.website.redesign.styles.RdMarkStyle
import com.anjuros.website.redesign.styles.RdSubpageTitleStyle
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.autoComplete
import org.jetbrains.compose.web.attributes.AutoComplete
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/** Title and intro, a search box that filters the questions, and buttons to jump to each topic. */
@Composable
fun FaqHeroSection(query: String, onQueryChange: (String) -> Unit) {
    val placeholderText = LocalText(RdText.FAQS_SEARCH_PLACEHOLDER)
    val topicsLabel = LocalText(RdText.FAQS_TOPICS_LABEL)
    RdSection(labelledBy = "h1", modifier = FaqHeroStyle.toModifier(), wrapModifier = FaqHeroInnerStyle.toModifier()) {
        RdBreadcrumb(RdText.FAQS_CRUMB)
        H1(RdSubpageTitleStyle.toModifier().id("h1").toAttrs()) {
            Text(LocalText(RdText.FAQS_HERO_TITLE_START))
            Span(RdMarkStyle.toModifier().toAttrs()) { Text(LocalText(RdText.FAQS_HERO_TITLE_MARK)) }
        }
        RdLede(RdText.FAQS_HERO_LEDE)
        Label(attrs = FaqSearchStyle.toModifier().toAttrs()) {
            Span(FaqVisuallyHiddenStyle.toModifier().toAttrs()) { Text(LocalText(RdText.FAQS_SEARCH_LABEL)) }
            RdIcons.Search(size = 20)
            Input(InputType.Search) {
                value(query)
                placeholder(placeholderText)
                autoComplete(AutoComplete.off)
                onInput { onQueryChange(it.value) }
            }
        }
        Ul(FaqChipsStyle.toModifier().attrsModifier { attr("aria-label", topicsLabel) }.toAttrs()) {
            FaqTopics.forEach { topic ->
                Li {
                    // Clear the search first, otherwise the topic may be filtered out.
                    A("#${topic.id}", attrs = {
                        onClick {
                            it.preventDefault()
                            onQueryChange("")
                            rdScrollToAfterRender(topic.id)
                        }
                    }) {
                        Text(LocalText(topic.shortTitle))
                    }
                }
            }
        }
    }
}
